import React, { useEffect, useRef } from 'react';
import { Animated, Vibration, View } from 'react-native';
import { Text, TextInput } from '../../components';
import { BaseColor } from '../../config';
//import Animated from 'react-native-reanimated';
export default function FormTextInput({ submitedInput, setInput, isLast, editable,isAssigned, positions }) {
    const animationRef = useRef(new Animated.Value(0));

    const highlight = () => {
        Vibration.vibrate(100);
        Animated.sequence([
            Animated.timing(animationRef.current, {
                toValue: 1,
                // set the duration
                duration: 500,
                useNativeDriver: false,
            }),
            // delay is optional
            Animated.delay(1000),
            Animated.timing(animationRef.current, {
                toValue: 0,
                duration: 500,
                // useNativeDriver:true, might not work with the all properties that you need to animate. true might improve animation performance
                useNativeDriver: false,
            }),
        ]).start();
    };

    useEffect(() => {
        if (editable && submitedInput.error) highlight();
    }, [submitedInput.checkInput]);

    return (
        <Animated.View
            style={{
                borderBottomColor: BaseColor.grayTransparent,
                borderBottomWidth: isLast ? 0 : 1,
                paddingBottom: 15,
                paddingTop: 10,
                paddingHorizontal: 15,
                backgroundColor: animationRef.current?.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['#fff', '#ccc'],
                }),
            }}
        >
            <View>
                <View style={{ paddingBottom: 5, flexDirection:'row' }}>
                                    <View style={{flex:1}}>
                                    <Text semibold>
                                        {submitedInput.input?.label}
                                        {submitedInput.input?.required && ' *'}
                                    </Text>
                
                                    {submitedInput.input?.description && (
                                        <Text grayColor footnote>
                                            {submitedInput?.input.description}
                                        </Text>
                                    )}</View>
                                    {(submitedInput.isAssigned ||submitedInput.isStandardADM)  &&
                                        <View style={{position:'absolute', top:-10, right:-15}}><View style={{padding:5, marginLeft:3,paddingHorizontal:8,  borderBottomLeftRadius:10, backgroundColor:BaseColor.blueColor}}><Text whiteColor  caption2>Für mich</Text></View></View>
                                    }
                                </View>
                {submitedInput.editable ? (
                    <TextInput
                        editable={submitedInput.editable}
                        multiline={submitedInput.input?.multiline}
                        onChangeText={(v) => setInput({ value: v })}
                        onFocus={() => setInput({ error: '' })}
                        placeholder={submitedInput.input?.placeholder ?? 'Ihre Antwort'}
                        success={!submitedInput.error}
                        value={submitedInput.value}
                        style={{ borderRadius: 0 }}
                        textError={submitedInput.error && 'Feld erforderlich'}
                    />
                ) : (
                    <View style={{ backgroundColor: BaseColor.card, padding: 10 }}>
                        <Text>{submitedInput.value}</Text>
                    </View>
                )}
            </View>
        </Animated.View>
    );
}
